import { CommonModule, DeprecatedI18NPipesModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CalloutModule } from '@shared/ui/callout/callout.module';
import { OnlineStatusModule } from '../online-status/online-status.module';
import { AlertComponent } from './alert/alert.component';
import { BudgetComponent } from './budget.component';
import { ButtonComponent } from './button/button.component';
import { ContainerComponent } from './container/container.component';
import { CurrencyComponent } from './currency.component';
import { EllipsisTextComponent } from './ellipsis-text/ellipsis-text.component';
import { EmojiPickerComponent } from './emoji-picker/emoji-picker.component';
import { EmojiPipe } from './emoji/emoji.pipe';
import { FlagComponent } from './flag/flag.component';
import { HighlightTextModule } from './highlight-text/highlight-text.module';
import { IconModule } from './icon/icon.module';
import { ImageThumbnailComponent } from './image-thumbnail/image-thumbnail.component';
import { InputComponent } from './input/input.component';
import { LayoutModule } from './layout/layout.module';
import { LinkModule } from './link/link.module';
import { LocalizedDateFns } from './localized-date-fns.service';
import { MediaObjectModule } from './media-object/media-object.module';
import { ModalModule } from './modal/modal.module';
import { NotificationIndicatorComponent } from './notification-indicator/notification-indicator.component';
import { PictureComponent } from './picture/picture.component';
import { RatingComponent } from './rating/rating.component';
import { RelativeTimeComponent } from './relative-time/relative-time.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TooltipModule } from './tooltip/tooltip.module';
import { UI_CONFIG } from './ui.config';
import { UiConfig } from './ui.interface';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

@NgModule({
  declarations: [
    AlertComponent,
    BudgetComponent,
    ButtonComponent,
    ContainerComponent,
    CurrencyComponent,
    EllipsisTextComponent,
    FlagComponent,
    ImageThumbnailComponent,
    InputComponent,
    NotificationIndicatorComponent,
    PictureComponent,
    RatingComponent,
    RelativeTimeComponent,
    SpinnerComponent,
    UserAvatarComponent,
    EmojiPickerComponent,
    EmojiPipe,
  ],
  exports: [
    AlertComponent,
    BudgetComponent,
    ButtonComponent,
    ContainerComponent,
    CurrencyComponent,
    EllipsisTextComponent,
    FlagComponent,
    HighlightTextModule,
    IconModule,
    ImageThumbnailComponent,
    InputComponent,
    LayoutModule,
    MediaObjectModule,
    NotificationIndicatorComponent,
    OnlineStatusModule,
    PictureComponent,
    RatingComponent,
    RelativeTimeComponent,
    SpinnerComponent,
    UserAvatarComponent,
    LinkModule,
    CalloutModule,
    EmojiPickerComponent,
    EmojiPipe,
    ModalModule,
    TooltipModule,
    UserAvatarComponent,
  ],
  imports: [
    CalloutModule,
    CommonModule,
    DeprecatedI18NPipesModule,
    HighlightTextModule,
    IconModule,
    LayoutModule,
    LinkModule,
    MediaObjectModule,
    ModalModule,
    OnlineStatusModule,
    ReactiveFormsModule,
    RouterModule,
    TooltipModule,
  ],
  // /!\ DO NOT ADD PROVIDERS HERE
})
export class UiModule {
  static initialize(config: UiConfig): ModuleWithProviders {
    return {
      ngModule: UiModule,
      providers: [{ provide: UI_CONFIG, useValue: config }, LocalizedDateFns],
    };
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/ui/ui.module.ts